import axios from "axios";
import { getApiBaseUrl } from "@/config/runtime";

const api = axios.create({
  baseURL: getApiBaseUrl() + "/api/v1",
  withCredentials: false,
});

export const useTemplateApi = () => ({
  /**
   * Récupère tous les templates
   */
  async getAll() {
    return api.get("/templates");
  },

  /**
   * Récupère les paramètres actuels d’un template
   */
  async getParameters(templateId: number | string) {
    return api.get(`/templates/${templateId}/parameters`);
  },

  /**
   * Sauvegarde les paramètres modifiés d’un template
   */
  async saveParameters(templateId: number | string, params: Record<string, any>) {
    return api.post(`/templates/${templateId}/parameters`, params);
  },

  /**
   * Définit le template par défaut pour une station
   */
  async selectTemplate(stationId: number, templateId: number | string) {
    return api.post(`/templates/select`, { station_id: stationId, template_id: templateId });
  },

  /**
   * Récupère la preview dynamique du template
   */
  async getPreview(templateId: number | string, params: Record<string, any>) {
    return api.post(`/templates/${templateId}/preview`, { params });
  },
});
